import { DATE_MEDIUM_WITHOUT_YEAR, DATE_WITHOUT_YEAR, FROM_NOW, RELATIVE_DAY } from './constants';
import { Format } from './formats';

/**
 * These decodes convert our constants into formats for the underlying formatting libraries
 * (numbro and dayjs)
 */
const FORMAT_DECODES: Record<Format, string> = {
  [Format.AREA]: '0,0.00 sq ft',
  [Format.PERCENTAGE]: '0,0.0%',
  [Format.SIGNED_PERCENTAGE]: '+0,0.0%',
  // NB: $ is used to represent the currency for numbro.js, it will be replaced by the currency code passed to `Money`
  [Format.MONEY]: '$0,0[.]00a',
  [Format.MONEY_TABLES]: '($0,0[.]00a)',
  [Format.MONEY_CUSTOM_ABBREVIATION]: '$0,0[.]00A',
  [Format.MONEY_TABLES_CUSTOM_ABBREVIATION]: '($0,0[.]00A)',
  [Format.MONEY_ABBREVIATED]: '0,0.0',
  [Format.MONEY_TABLES_ABBREVIATED_ONES]: '(0,0)',
  [Format.MONEY_TABLES_ABBREVIATED]: '(0,0.0)',
  [Format.MONEY_TABLES_ABBREVIATED_HUNDREDTHS]: '(0,0.00)',
  [Format.MONEY_TRILLIONS]: '0,0.0aT',
  [Format.MONEY_TRILLIONS_CURRENCY]: '$0,0.0aT',
  [Format.MONEY_BILLIONS]: '0,0.0aB',
  [Format.MONEY_BILLIONS_CURRENCY]: '$0,0.0aB',
  [Format.MONEY_MILLIONS]: '0,0.0aM',
  [Format.MONEY_MILLIONS_CURRENCY]: '$0,0.0aM',
  [Format.MONEY_THOUSANDS]: '0,0.0aK',
  [Format.MONEY_THOUSANDS_CURRENCY]: '$0,0.0aK',
  [Format.MONEY_ONES]: '0,0[.]00',
  [Format.MONEY_ONES_CURRENCY]: '$0,0[.]00',
  [Format.RATIO]: '0,0.00x',
  [Format.NUMBER]: '0,0[.][00]a',
  [Format.NUMBER_CUSTOM_ABBREVIATION]: '0,0[.][00]A',
  [Format.INTEGER]: '0,0a',
  [Format.SIGNED_INTEGER]: '+0,0a',
  [Format.INTEGER_NO_ABBREVIATION]: '0,0',
  [Format.INTEGER_CUSTOM_ABBREVIATION]: '0,0A',
  [Format.YEAR]: '0',
  [Format.FROM_NOW]: FROM_NOW,
  [Format.DATE_WITHOUT_YEAR]: DATE_WITHOUT_YEAR,
  [Format.DATE_MEDIUM_WITHOUT_YEAR]: DATE_MEDIUM_WITHOUT_YEAR,
  [Format.DATE_YEAR_ONLY]: 'YYYY',
  [Format.DATE_MONTH_YEAR]: 'MMM YYYY',
  [Format.DATE_MONTH_YEAR_SHORT]: 'MM/YY',
  [Format.DATE_SHORT]: 'L',
  [Format.DATE_MEDIUM]: 'll',
  [Format.DATE_MEDIUM_WITH_TIME]: 'lll',
  [Format.DATE_LONG]: 'LL',
  [Format.DATE_LONG_WITH_TIME]: 'LLL',
  [Format.TIME]: 'LT',
  [Format.TIME_WITH_SECONDS]: 'LTS',
  [Format.TIME_WITH_MILLISECONDS]: 'HH:mm:ss.SSS',
  [Format.RELATIVE_DAY]: RELATIVE_DAY,
};

// Overloads to tell TS that if a known `Format` is provided, we will always return a string
export function decode(format: Format): string;
export function decode(format: string | undefined): string | undefined;
export function decode(format: string | undefined): string | undefined {
  if (!format) {
    return format;
  }
  const decodedFormat = FORMAT_DECODES[format as Format];
  if (!decodedFormat) {
    if (process.env.NODE_ENV !== 'production') {
      throw new Error(`Unknown format ${format}`);
    }
    console.warn(`Unknown format ${format} - using default format`);
    return undefined;
  }
  return decodedFormat;
}
